import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { PimProductInfo, ProductsService, TechnicalAttribute } from '../../services/products.service';
import { ProductDetailsDialogComponent } from './product-details-dialog/product-details-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-product-details',
    standalone: true,
    imports: [MatIcon, MatIconButton, MatTooltip],
    templateUrl: './product-details.component.html',
    styleUrl: './product-details.component.scss',
})
export class ProductDetailsComponent {
    @Input() productDescription: string;
    @Input() material: string;
    @Input() productDetails: string[];

    constructor(private productsService: ProductsService, private dialog: MatDialog) {}

    public getProductDetails() {
        this.productsService
            .getMaterialInfos([this.material], this.productDetails, ['attributes'], false, false)
            .subscribe((response: PimProductInfo[]) => {
                this.openProductDetailsDialog(
                    this.productDescription,
                    this.sortTechnicalAttributes(this.productDetails, response[0].technicalAttributes)
                );
            });
    }

    private openProductDetailsDialog(description: string, technicalAttributes: TechnicalAttribute[]) {
        this.dialog.open(ProductDetailsDialogComponent, {
            data: {
                description,
                technicalAttributes,
            },
        });
    }

    private sortTechnicalAttributes(
        details: string[],
        technicalAttributes: TechnicalAttribute[]
    ): TechnicalAttribute[] {
        const orderMap = new Map(details.map((id, index) => [id, index]));
        return technicalAttributes.sort(
            (a, b) =>
                (orderMap.get(a.attributeId) ?? Number.MAX_SAFE_INTEGER) -
                (orderMap.get(b.attributeId) ?? Number.MAX_SAFE_INTEGER)
        );
    }
}
